import { FC } from 'react';
import LessonProgressBorder from './lessonProgressBorder';
import styles from './pieChart.module.scss';

const PieChart: FC<{
    percentage: number;
    showPercentage?: boolean;
    size?: number;
    lineWidth?: number;
    top?: string;
    left?: string;
}> = ({
    percentage,
    showPercentage = true,
    size = 50,
    lineWidth = 6,
    top = '-0.1rem',
    left = '-1.4rem'
}: {
    percentage: number;
    showPercentage?: boolean;
    size?: number;
    lineWidth?: number;
    top?: string;
    left?: string;
}) => {
    return (
        <div className={styles['pie-circle-chart']}>
            <div className={styles.main} style={{ width: `${size / 16}rem`, height: `${size / 16}rem` }}>
                {showPercentage && <div className={styles['fixed-center']}>{percentage}%</div>}
            </div>

            <div className={styles['progress-wrapper']} style={{ '--top': top, '--left': left } as any}>
                <LessonProgressBorder percentage={percentage} size={size} lineWidth={lineWidth} />
            </div>
        </div>
    );
};

export default PieChart;
